import React from 'react';
import { Box, Typography } from '@mui/material';
import { valuesSectionStyles } from './ValuesSection.styles';
import { aboutHeadingStyle, aboutTitleStyle } from '../../../../styles/aboutTextStyles';
import UserGroup from '../../../../assets/about/user-group.png';
import CouchImage from '../../../../assets/about/centerImage.png';
import IconInfoSection from '../../../../components/IconInfoSection/IconInfoSection';
import QuestionIcon from '../../../../assets/about/question.png';
import SelectIcon from '../../../../assets/about/select.png';

const ValuesSection = () => {
  const styles = valuesSectionStyles();

  return (
    <Box sx={styles.container}>
      <Box sx={styles.contentContainer}>
        <Typography sx={[aboutHeadingStyle, styles.heading]}>
          Our Values
        </Typography>
        <Box sx={styles.titleContainer}>
          <Typography sx={[aboutTitleStyle, styles.title]}>
            Why Choose
          </Typography>
          <Typography sx={[aboutTitleStyle, styles.title]}>
            Royal Vista
          </Typography>
        </Box>
      </Box>
      <Box
        sx={styles.couchBackground}
        style={{ backgroundImage: `url(${CouchImage})` }}
      />
      {/* Icon Info Sections */}
      <Box sx={styles.iconInfoSection1}>
        <IconInfoSection
          icon={UserGroup}
          title="Families Welcome"
          subtitle="Perfect for any family looking for quality and comfort."
        />
      </Box>
      <Box sx={styles.iconInfoSection2}>
        <IconInfoSection
          icon={QuestionIcon}
          title="Personal Concierge"
          subtitle="Enjoy unique benefits and tailored experiences with us."
        />
      </Box>
      <Box sx={styles.iconInfoSection3}>
        <IconInfoSection
          icon={SelectIcon}
          title="Hassle Free Check-In"
          subtitle="24/7 Guest Communication for ensuring a seamless experience."
        />
      </Box>
    </Box>
  );
};

export default ValuesSection;

